module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "part-a-hellenistic-fire"
    }
  }, [_c('h1'), _vm._v(" "), _c('h1', [_vm._v("Part A:"), _c('br'), _vm._v(" Hellenistic Fire")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Understand that you are a god—the rule of reason and freewill over your mind and body—is like the rule of God himself over the physical universe.")])]), _vm._v(" "), _c('p', [_vm._v("(Cicero, "), _c('em', [_vm._v("de re publica")]), _vm._v(", Bk. VI Somnium Scipionis)")]), _vm._v(" "), _c('p', [_c('strong', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d959b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 87
// module chunks = 0